import detskiyMir from "./detskiy-mir"
import transport from "./transport"
import realState from "./real-state"
import work from "./work"
import animals from "./animals"
import homeTrees from "./home-trees"
import electronik from "./electronik"
import business from "./business"
import moda from "./moda"
// import hobby from "./hobby"
// import give from "./give"
// import exchange from "./exchange"

const data = [
    { category: "detskiy-mir", data: detskiyMir },
    { category: "transport", data: transport },
    { category: "real-state", data: realState },
    { category: "work", data: work },
    { category: "animals", data: animals },
    { category: "home-trees", data: homeTrees },
    { category: "electronik", data: electronik },
    { category: "business", data: business },
    { category: "moda", data: moda },
    // { category: "hobby", data: hobby },
    // { category: "give", data: give },
    // { category: "exchange", data: exchange },
]

export default data;